// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/system_mutation.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import {SilentHours, System, SystemProductionState} from "./system_pb.js";

/**
 * @generated from message wavin.aqora.v2.UpsertSystemRequest
 */
export const UpsertSystemRequest = proto3.makeMessageType(
  "wavin.aqora.v2.UpsertSystemRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "production_state", kind: "enum", T: proto3.getEnumType(SystemProductionState) },
    { no: 6, name: "crm_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "remarks", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "growing_months", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
    { no: 9, name: "service_contract_end_date", kind: "message", T: Timestamp },
    { no: 10, name: "min_temperature", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    {no: 11, name: "silent_hours", kind: "message", T: SilentHours},
  ],
);

/**
 * @generated from message wavin.aqora.v2.UpsertSystemResponse
 */
export const UpsertSystemResponse = proto3.makeMessageType(
  "wavin.aqora.v2.UpsertSystemResponse",
  () => [
    { no: 1, name: "success", kind: "message", T: UpsertSystemResponse_Success, oneof: "outcome" },
    { no: 2, name: "failure", kind: "message", T: UpsertSystemResponse_Failure, oneof: "outcome" },
  ],
);

/**
 * @generated from enum wavin.aqora.v2.UpsertSystemResponse.Field
 */
export const UpsertSystemResponse_Field = proto3.makeEnum(
  "wavin.aqora.v2.UpsertSystemResponse.Field",
  [
    {no: 0, name: "FIELD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FIELD_NAME", localName: "NAME"},
    {no: 2, name: "FIELD_TITLE", localName: "TITLE"},
    {no: 3, name: "FIELD_GOOGLE_PLACE_ID", localName: "GOOGLE_PLACE_ID"},
    {no: 5, name: "FIELD_PRODUCTION_STATE", localName: "PRODUCTION_STATE"},
    {no: 6, name: "FIELD_CRM_NUMBER", localName: "CRM_NUMBER"},
    {no: 7, name: "FIELD_REMARKS", localName: "REMARKS"},
    {no: 8, name: "FIELD_GROWING_MONTHS", localName: "GROWING_MONTHS"},
    {no: 9, name: "FIELD_SERVICE_CONTRACT_END_DATE", localName: "SERVICE_CONTRACT_END_DATE"},
    {no: 10, name: "FIELD_MIN_TEMPERATURE", localName: "MIN_TEMPERATURE"},
    {no: 11, name: "FIELD_SILENT_HOURS", localName: "SILENT_HOURS"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.UpsertSystemResponse.Success
 */
export const UpsertSystemResponse_Success = proto3.makeMessageType(
  "wavin.aqora.v2.UpsertSystemResponse.Success",
  () => [
    { no: 1, name: "system", kind: "message", T: System },
  ],
  {localName: "UpsertSystemResponse_Success"},
);

/**
 * @generated from message wavin.aqora.v2.UpsertSystemResponse.FieldError
 */
export const UpsertSystemResponse_FieldError = proto3.makeMessageType(
  "wavin.aqora.v2.UpsertSystemResponse.FieldError",
  () => [
    { no: 1, name: "field", kind: "enum", T: proto3.getEnumType(UpsertSystemResponse_Field) },
    { no: 2, name: "error", kind: "message", T: TranslatableError },
  ],
  {localName: "UpsertSystemResponse_FieldError"},
);

/**
 * @generated from message wavin.aqora.v2.UpsertSystemResponse.Failure
 */
export const UpsertSystemResponse_Failure = proto3.makeMessageType(
  "wavin.aqora.v2.UpsertSystemResponse.Failure",
  () => [
    { no: 1, name: "errors", kind: "message", T: TranslatableError, repeated: true },
    { no: 2, name: "field_errors", kind: "message", T: UpsertSystemResponse_FieldError, repeated: true },
  ],
  {localName: "UpsertSystemResponse_Failure"},
);

/**
 * @generated from message wavin.aqora.v2.TranslatableError
 */
export const TranslatableError = proto3.makeMessageType(
  "wavin.aqora.v2.TranslatableError",
  () => [
    {no: 3, name: "too_low", kind: "message", T: TranslatableError_TooLow, oneof: "type"},
    {no: 4, name: "too_high", kind: "message", T: TranslatableError_TooHigh, oneof: "type"},
    {no: 5, name: "missing", kind: "message", T: TranslatableError_Missing, oneof: "type"},
    {no: 6, name: "not_found", kind: "message", T: TranslatableError_NotFound, oneof: "type"},
    {no: 7, name: "invalid_type", kind: "message", T: TranslatableError_InvalidType, oneof: "type"},
    {no: 8, name: "configuration_error", kind: "message", T: TranslatableError_ConfigurationError, oneof: "type"},
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message wavin.aqora.v2.TranslatableError.TooLow
 */
export const TranslatableError_TooLow = proto3.makeMessageType(
  "wavin.aqora.v2.TranslatableError.TooLow",
  () => [
    {no: 1, name: "min", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
  ],
  {localName: "TranslatableError_TooLow"},
);

/**
 * @generated from message wavin.aqora.v2.TranslatableError.TooHigh
 */
export const TranslatableError_TooHigh = proto3.makeMessageType(
  "wavin.aqora.v2.TranslatableError.TooHigh",
  () => [
    {no: 1, name: "max", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
  ],
  {localName: "TranslatableError_TooHigh"},
);

/**
 * @generated from message wavin.aqora.v2.TranslatableError.Missing
 */
export const TranslatableError_Missing = proto3.makeMessageType(
  "wavin.aqora.v2.TranslatableError.Missing",
  [],
  {localName: "TranslatableError_Missing"},
);

/**
 * @generated from message wavin.aqora.v2.TranslatableError.NotFound
 */
export const TranslatableError_NotFound = proto3.makeMessageType(
  "wavin.aqora.v2.TranslatableError.NotFound",
  [],
  {localName: "TranslatableError_NotFound"},
);

/**
 * @generated from message wavin.aqora.v2.TranslatableError.InvalidType
 */
export const TranslatableError_InvalidType = proto3.makeMessageType(
  "wavin.aqora.v2.TranslatableError.InvalidType",
  [],
  {localName: "TranslatableError_InvalidType"},
);

/**
 * @generated from message wavin.aqora.v2.TranslatableError.ConfigurationError
 */
export const TranslatableError_ConfigurationError = proto3.makeMessageType(
  "wavin.aqora.v2.TranslatableError.ConfigurationError",
  () => [
    {no: 1, name: "target", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
  {localName: "TranslatableError_ConfigurationError"},
);

/**
 * @generated from message wavin.aqora.v2.DeleteSystemRequest
 */
export const DeleteSystemRequest = proto3.makeMessageType(
  "wavin.aqora.v2.DeleteSystemRequest",
  () => [
    {no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.DeleteSystemResponse
 */
export const DeleteSystemResponse = proto3.makeMessageType(
  "wavin.aqora.v2.DeleteSystemResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.UpdateSystemProductionStateRequest
 */
export const UpdateSystemProductionStateRequest = proto3.makeMessageType(
  "wavin.aqora.v2.UpdateSystemProductionStateRequest",
  () => [
    {no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "production_state", kind: "enum", T: proto3.getEnumType(SystemProductionState)},
    {no: 3, name: "dummy_run", kind: "scalar", T: 8 /* ScalarType.BOOL */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.UpdateSystemProductionStateResponse
 */
export const UpdateSystemProductionStateResponse = proto3.makeMessageType(
  "wavin.aqora.v2.UpdateSystemProductionStateResponse",
  () => [
    {no: 1, name: "success", kind: "message", T: UpdateSystemProductionStateResponse_Success, oneof: "outcome"},
    {no: 2, name: "failure", kind: "message", T: UpdateSystemProductionStateResponse_Failure, oneof: "outcome"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.UpdateSystemProductionStateResponse.Field
 */
export const UpdateSystemProductionStateResponse_Field = proto3.makeEnum(
  "wavin.aqora.v2.UpdateSystemProductionStateResponse.Field",
  [
    {no: 0, name: "FIELD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FIELD_UNLINKED_TAP", localName: "UNLINKED_TAP"},
    {no: 2, name: "FIELD_UNLINKED_RAIN", localName: "UNLINKED_RAIN"},
    {no: 3, name: "FIELD_FLOATING_RESERVOIR", localName: "FLOATING_RESERVOIR"},
    {no: 4, name: "FIELD_NO_RESERVOIRS_EXISTS", localName: "NO_RESERVOIRS_EXISTS"},
    {no: 5, name: "FIELD_NO_PRODUCTS_EXISTS", localName: "NO_PRODUCTS_EXISTS"},
    {no: 6, name: "FIELD_NOT_COMMISSIONED_DEVICE", localName: "NOT_COMMISSIONED_DEVICE"},
    {no: 7, name: "FIELD_RAIN_MISSING", localName: "RAIN_MISSING"},
    {no: 8, name: "FIELD_POLDERVALVE_COUNT_LOW", localName: "POLDERVALVE_COUNT_LOW"},
    {no: 9, name: "FIELD_POLDERVALVE_INVALID_DRAIN_TYPE", localName: "POLDERVALVE_INVALID_DRAIN_TYPE"},
    {no: 10, name: "FIELD_NO_SMART_DEVICES", localName: "NO_SMART_DEVICES"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.UpdateSystemProductionStateResponse.Success
 */
export const UpdateSystemProductionStateResponse_Success = proto3.makeMessageType(
  "wavin.aqora.v2.UpdateSystemProductionStateResponse.Success",
  () => [
    {no: 1, name: "dummy_run", kind: "scalar", T: 8 /* ScalarType.BOOL */},
  ],
  {localName: "UpdateSystemProductionStateResponse_Success"},
);

/**
 * @generated from message wavin.aqora.v2.UpdateSystemProductionStateResponse.FieldError
 */
export const UpdateSystemProductionStateResponse_FieldError = proto3.makeMessageType(
  "wavin.aqora.v2.UpdateSystemProductionStateResponse.FieldError",
  () => [
    {no: 1, name: "field", kind: "enum", T: proto3.getEnumType(UpdateSystemProductionStateResponse_Field)},
    {no: 2, name: "error", kind: "message", T: TranslatableError},
  ],
  {localName: "UpdateSystemProductionStateResponse_FieldError"},
);

/**
 * @generated from message wavin.aqora.v2.UpdateSystemProductionStateResponse.Failure
 */
export const UpdateSystemProductionStateResponse_Failure = proto3.makeMessageType(
  "wavin.aqora.v2.UpdateSystemProductionStateResponse.Failure",
  () => [
    {no: 1, name: "errors", kind: "message", T: TranslatableError, repeated: true},
    {no: 2, name: "field_errors", kind: "message", T: UpdateSystemProductionStateResponse_FieldError, repeated: true},
  ],
  {localName: "UpdateSystemProductionStateResponse_Failure"},
);

